import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Story } from "./components/Story";
import { Menu } from "./components/Menu";
import { Gallery } from "./components/Gallery";
import { Visit } from "./components/Visit";
import { Footer } from "./components/Footer";
import MenuAdmin from "./pages/MenuAdmin";
import useReveal from "./hooks/useReveal";

const Landing = () => {
  useReveal();
  return (
    <div className="App" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Story />
        <Menu />
        <Gallery />
        <Visit />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin/menu" element={<MenuAdmin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
